import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useApiClient } from "@playbookai/api-clients";
import { kpiApi } from "../api/live-client.js";
import { kpiKeys } from "./kpiQueryKeys.js";

/** One server-backed page for the browsable KPI Library. */
export function useKpiDefinitionPage(
  cursor: string | undefined,
  limit: number,
) {
  const config = useApiClient();
  return useQuery({
    queryKey: kpiKeys.definitionPage(cursor, limit),
    queryFn: () =>
      kpiApi.listDefinitionPage(config, {
        limit,
        ...(cursor ? { cursor } : {}),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60_000,
  });
}
